import React, { useEffect, useState } from "react";
import { fetchChildrenUsers } from "../../../../services/reportsDataService";
import { styled, Typography } from "@mui/material";
import CompactCheckboxDropdown, {
  Option,
} from "./ReplEdititingFilters/CompactCheckboxDropdown";

interface WeekDaysFilterProps {
  value: string[];
  options: Option[];
  onChange: (value: string[]) => void;
  loading?: boolean;
  onOpen?: () => void;
}
interface Props {
  name: string;
  values: any;
  setValues: React.Dispatch<React.SetStateAction<any>>;
}

const WeekDaysFilter: React.FC<WeekDaysFilterProps> = ({
  value,
  options,
  onChange,
  loading,
  onOpen,
}) => {
  return (
    <CompactCheckboxDropdown
      label="Select Days"
      options={options}
      selectedValues={Array.isArray(value) ? value : []}
      onChange={onChange}
      placeholder="Select Days"
      width={200}
      loading={loading}
      enableSelectAll
      selectAllLabel="Select All Days"
      onOpen={onOpen}
      disableSearchBar={true}
    />
  );
};

const WeekDaysTypeFilter = (props: Props) => {
  const [weekDayOptions, setWeekDayOptions] = useState<any>([]);
  const [weekDayLoading, setWeekDayLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<any>({});
  const handleSalesManChange = (values: string[]) => {
    setFilters((prev: any) => ({
      ...prev,
      weekdays: values,
    }));
    props.setValues({
      ...props.values,
      ["weekdays"]: {
        ...props.values?.["weekdays"],
        value: values,
      },
    });
  };

  const fetchWeekDays = () => {
    setWeekDayLoading(true);
    try {
      setWeekDayOptions([
        { label: "Monday", value: "monday" },
        { label: "Tuesday", value: "tuesday" },
        { label: "Wednesday", value: "wednesday" },
        { label: "Thursday", value: "thursday" },
        { label: "Friday", value: "friday" },
        { label: "Saturday", value: "saturday" },
        { label: "Sunday", value: "sunday" },
      ]);
    } catch (err) {
      console.error("Error", err);
    } finally {
      setWeekDayLoading(false);
    }
  };

  const Wrapper = styled("div")(`
    font-size:15px;
    text-align:left;
    padding-left:0.2rem;
    font-weight:500;
   margin-bottom: 8px;
    
    &::first-letter {
    text-transform: capitalize;
    }
  `);

  return (
    <>
      <Wrapper>
        Select Allowed Days for Manual Primary Order
        <Typography
          component="span"
          sx={{ color: "red", ml: "4px", mr: "4px" }}
        >
          *
        </Typography>
      </Wrapper>
      <WeekDaysFilter
        value={filters?.weekdays ?? []}
        options={weekDayOptions}
        onChange={(values) => {
          handleSalesManChange(values);
        }}
        loading={weekDayLoading}
        onOpen={fetchWeekDays}
      />
    </>
  );
};

export default WeekDaysTypeFilter;
